import React from "react";
import logo from '../../Assets/Images/login_logo.png';
function Footer() {
  const currentYear = new Date().getFullYear();
  const appName = process.env.REACT_APP_NAME;

  return (
    <footer className="db">
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <img src={logo} className="img-fluid logo" alt="Logo" />
        </div>
        <div className="text-center">
          <p class="m-0">Copyright © {appName} {currentYear}. All rights reserved.</p>
        </div>
        <div>
          <ul className="social-media list-unstyled d-flex gap-2 m-0">
            <li>
              <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-facebook-f"></i>
              </a>
            </li>
            <li>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-x-twitter"></i>
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-instagram"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
